import React from 'react';

const HeaderSection = ({ title = "Advancing Language Accessibility And Innovation", subtitle = "At NKENNEAi, we are taking the necessary steps to ensure African languages thrive in the digital world." }) => {
  return (
    <div className="flex flex-col items-center text-center w-full max-w-[1189px] px-4 md:px-6 py-8 gap-2">
      <h2 className="text-[#ef8702] font-black text-base md:text-lg">
        OUR GOALS
      </h2>
      <h1 className="text-black font-black text-3xl md:text-4xl lg:text-[45px] leading-tight">
        {title}
      </h1>
      <p className="text-gray-800 text-sm md:text-base max-w-[90%]">
        {subtitle}
      </p>
    </div>
  );
};

export default HeaderSection;

